import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { CheckCircle } from 'lucide-react';

interface NotificationProps {
  message: string;
  onClose: () => void;
  duration?: number; // Duración en milisegundos
}

const Notification: React.FC<NotificationProps> = ({ message, onClose, duration = 3500 }) => {
  const [progress, setProgress] = useState(100);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prev) => (prev > 0 ? prev - 1 : 0));
    }, duration / 100);

    const timeout = setTimeout(() => {
      onClose();
    }, duration);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [duration, onClose]);

  // Intentar obtener el contenedor del portal
  const container = document.getElementById('notification-root') || document.body;

  return ReactDOM.createPortal(
    <div className="fixed bottom-20 left-1/2 transform -translate-x-1/2 bg-green-600 text-white px-6 py-4 rounded-lg shadow-lg flex items-center gap-3 w-full max-w-md z-[11000]">
      <CheckCircle className="w-6 h-6 text-white" />
      <span className="flex-1">{message}</span>
      <div className="absolute bottom-0 left-0 w-full h-1 bg-green-400">
        <div className="h-1 bg-white transition-all" style={{ width: `${progress}%` }} />
      </div>
    </div>,
    container
  );
};

export default Notification;
